export default ["image/gif", "image/jpeg", "image/png"]
